import React, {useEffect, useRef, useState} from "react";
import {FormGroup, FormLabel} from "react-bootstrap";
import {HexColorPicker, RgbaColorPicker} from "react-colorful";
import {MY_DESIGN_DETAIL_TYPE_COLOR_RGBA} from "../../const/MyDesignDetailTypeConst.ts";

interface MyDesignColorProps{
    dto?: DesignTemplateDetailDto;
    addClassName?: string;
    handleChange?: () => void;
}
const MyDesignColor:React.FC<MyDesignColorProps> = ({
    dto = undefined,
    addClassName = '',
    handleChange,
}) => {
    const [isRgbaColor, setIsRgbaColor] = useState<boolean>(false);
    useEffect(() => {
        setIsRgbaColor(dto?.type === MY_DESIGN_DETAIL_TYPE_COLOR_RGBA)
        if(dto?.type === MY_DESIGN_DETAIL_TYPE_COLOR_RGBA){
            setBackColor({
                r: 255,
                g: 255,
                b: 255,
                a: 0.5,
            });
        }else {
            setForeColor("#FFFFFF");
        }
    }, [dto]);
    const [backColor, setBackColor] = useState<ColorDto>({
        r: 255,
        g: 255,
        b: 255,
        a: 0.5,
    });
    useEffect(() => {
        if(dto){
            dto.content = `rgba(${backColor.r}, ${backColor.g}, ${backColor.b}, ${backColor.a})`;
        }
    }, [backColor]);
    const [foreColor, setForeColor] = useState<string>("#FFFFFF");
    useEffect(() => {
        if(dto){
            dto.content = foreColor;
        }
    }, [foreColor]);
    const debounceTimerRef = useRef<NodeJS.Timeout | null>(null);
    const onChangeColor = (color: ColorDto) => {
        setBackColor(color);
        if(handleChange){
            if (debounceTimerRef.current) {
                clearTimeout(debounceTimerRef.current);
            }
            debounceTimerRef.current = setTimeout(() => {
                handleChange();
            }, 300);
        }
    }
    const onChangeForeColor = (color: string) => {
        setForeColor(color);
        if(handleChange){
            if (debounceTimerRef.current) {
                clearTimeout(debounceTimerRef.current);
            }
            debounceTimerRef.current = setTimeout(() => {
                handleChange();
            }, 300);
        }
    }
    return <FormGroup className={addClassName}>
        <FormLabel className="my-design-input-title">{dto?.title}</FormLabel>
        {isRgbaColor? (
            <RgbaColorPicker color={backColor} onChange={onChangeColor} />
        ): (
            <HexColorPicker color={foreColor} onChange={onChangeForeColor}/>
        )}
    </FormGroup>;
};
export default MyDesignColor;